import axios from "axios";
import { silentRequest } from "../authConfig";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * @function GetJobProcess check job process
 * @param {Object} payload {instance, account, id}
 * @returns response
 */
export const GetJobProcess = (payload) => {
  return new Promise((resolve, reject) => {
    payload.instance
      .acquireTokenSilent({ ...silentRequest, account: payload.account })
      .then((tokenResponse) => {
        axios
          .get(API_URL + "/jobs/" + payload.id, {
            headers: {
              Authorization: "Bearer " + tokenResponse.accessToken,
            },
          })
          .then((res) => {
            resolve(res);
          });
      })
      .catch((error) => {
        console.log(error);
        payload.instance.acquireTokenRedirect(silentRequest);
        reject();
      });
  });
};
